import React, { useState } from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { Search, Save, Delete, Add, Edit, Check, Close } from '@mui/icons-material';

// Importar os novos componentes
import { Button, Input, Card, Badge } from '../components/core';
import HeaderModern from '../components/layout/HeaderModern';

/**
 * Página de demonstração dos componentes Mexx redesenhados
 * Fase 1: Componentes Core e Layout Base
 */
const MexxShowcase = () => {
  const [inputValue, setInputValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [notificationCount, setNotificationCount] = useState(3);

  const mockUser = {
    name: 'João Silva',
    email: 'joao.silva@mexx.ai',
    role: 'Supervisor',
    avatar: null
  };

  return (
    <>
      {/* Header Moderno */}
      <HeaderModern
        title="Sistema Mexx 2DO"
        user={mockUser}
        onMenuToggle={() => console.log('Menu toggle')}
        onLogout={() => console.log('Logout')}
        notificationCount={notificationCount}
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearchSubmit={(value) => console.log('Search:', value)}
      />

      {/* Container Principal */}
      <Container maxWidth="lg" style={{ marginTop: 80, paddingTop: 32, paddingBottom: 32 }}>

        {/* Título da Página */}
        <Box mb={4}>
          <Typography variant="h3" style={{ fontWeight: 600, color: 'var(--text-primary)' }}>
            🎨 Showcase Mexx Design System
          </Typography>
          <Typography variant="subtitle1" style={{ color: 'var(--text-secondary)', marginTop: 8 }}>
            Fase 1: Componentes Core com identidade visual Mexx
          </Typography>
        </Box>

        {/* Seção de Botões */}
        <Box mb={6}>
          <Typography variant="h5" gutterBottom style={{ color: 'var(--mexx-green-primary)', fontWeight: 500 }}>
            Botões
          </Typography>

          <Grid container spacing={3}>
            {/* Variantes */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Variantes
              </Typography>
              <Box display="flex" gap={2} flexWrap="wrap">
                <Button variant="primary">Primário</Button>
                <Button variant="secondary">Secundário</Button>
                <Button variant="ghost">Ghost</Button>
                <Button variant="danger">Danger</Button>
                <Button variant="success">Sucesso</Button>
                <Button variant="warning">Atenção</Button>
                <Button variant="info">Info</Button>
              </Box>
            </Grid>

            {/* Tamanhos */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Tamanhos
              </Typography>
              <Box display="flex" gap={2} alignItems="center">
                <Button size="small">Pequeno</Button>
                <Button size="medium">Médio</Button>
                <Button size="large">Grande</Button>
              </Box>
            </Grid>

            {/* Com Ícones */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Com Ícones
              </Typography>
              <Box display="flex" gap={2} flexWrap="wrap">
                <Button startIcon={<Add />}>Adicionar</Button>
                <Button variant="secondary" startIcon={<Edit />}>Editar</Button>
                <Button variant="danger" startIcon={<Delete />}>Excluir</Button>
                <Button variant="success" endIcon={<Check />}>Salvar</Button>
              </Box>
            </Grid>

            {/* Estados */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Estados
              </Typography>
              <Box display="flex" gap={2} flexWrap="wrap">
                <Button disabled>Desabilitado</Button>
                <Button loading>Carregando</Button>
                <Button fullWidth style={{ maxWidth: 200 }}>Full Width</Button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Seção de Inputs */}
        <Box mb={6}>
          <Typography variant="h5" gutterBottom style={{ color: 'var(--mexx-green-primary)', fontWeight: 500 }}>
            Inputs
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Input
                label="Nome completo"
                placeholder="Digite seu nome"
                helperText="Este é um texto de ajuda"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Input
                label="E-mail"
                type="email"
                placeholder="seu@email.com"
                required
                startIcon={<span>@</span>}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Input
                label="Buscar"
                placeholder="Pesquisar..."
                startIcon={<Search />}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Input
                label="Campo com erro"
                error="Este campo é obrigatório"
                placeholder="Digite algo"
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Input
                label="Pequeno"
                size="small"
                placeholder="Input pequeno"
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Input
                label="Médio"
                size="medium"
                placeholder="Input médio"
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Input
                label="Grande"
                size="large"
                placeholder="Input grande"
              />
            </Grid>

            <Grid item xs={12}>
              <Input
                label="Desabilitado"
                disabled
                placeholder="Campo desabilitado"
                value="Conteúdo não editável"
              />
            </Grid>
          </Grid>
        </Box>

        {/* Seção de Cards */}
        <Box mb={6}>
          <Typography variant="h5" gutterBottom style={{ color: 'var(--mexx-green-primary)', fontWeight: 500 }}>
            Cards
          </Typography>

          <Grid container spacing={3}>
            {/* Card Default */}
            <Grid item xs={12} md={6} lg={4}>
              <Card>
                <Typography variant="h6" gutterBottom>Card Default</Typography>
                <Typography variant="body2" color="textSecondary">
                  Este é um card padrão com conteúdo simples e bordas sutis.
                </Typography>
              </Card>
            </Grid>

            {/* Card Elevado */}
            <Grid item xs={12} md={6} lg={4}>
              <Card variant="elevated" elevation="large">
                <Typography variant="h6" gutterBottom>Card Elevado</Typography>
                <Typography variant="body2" color="textSecondary">
                  Card com sombra elevada para destaque visual.
                </Typography>
              </Card>
            </Grid>

            {/* Card com Header */}
            <Grid item xs={12} md={6} lg={4}>
              <Card
                header={
                  <Card.Header
                    title="Card com Header"
                    subtitle="Subtítulo do card"
                    icon={<Check />}
                  />
                }
              >
                <Typography variant="body2">
                  Conteúdo principal do card com header customizado.
                </Typography>
              </Card>
            </Grid>

            {/* Card de Sucesso */}
            <Grid item xs={12} md={6} lg={4}>
              <Card variant="success">
                <Typography variant="h6" gutterBottom>Sucesso!</Typography>
                <Typography variant="body2">
                  Operação realizada com sucesso. Usando a cor verde Mexx.
                </Typography>
              </Card>
            </Grid>

            {/* Card de Warning */}
            <Grid item xs={12} md={6} lg={4}>
              <Card variant="warning">
                <Typography variant="h6" gutterBottom>Atenção</Typography>
                <Typography variant="body2">
                  Este é um aviso importante para o usuário.
                </Typography>
              </Card>
            </Grid>

            {/* Card Clicável */}
            <Grid item xs={12} md={6} lg={4}>
              <Card
                clickable
                hoverable
                onClick={() => alert('Card clicado!')}
              >
                <Typography variant="h6" gutterBottom>Card Interativo</Typography>
                <Typography variant="body2" color="textSecondary">
                  Clique neste card para ver a interação.
                </Typography>
              </Card>
            </Grid>

            {/* Card com Footer */}
            <Grid item xs={12}>
              <Card
                header={
                  <Card.Header
                    title="KPI Card"
                    subtitle="Exemplo de card para Dashboard"
                    icon={<span style={{ fontSize: 24 }}>📊</span>}
                  />
                }
                footer={
                  <Card.Footer>
                    <Button variant="ghost" size="small">Ver Detalhes</Button>
                    <Button variant="primary" size="small">Ação Principal</Button>
                  </Card.Footer>
                }
              >
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="h4" style={{ color: 'var(--mexx-green-primary)' }}>
                      1,234
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Total de Tickets
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h4" style={{ color: 'var(--status-warning)' }}>
                      89%
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Taxa de Resolução
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Box>

        {/* Seção de Badges */}
        <Box mb={6}>
          <Typography variant="h5" gutterBottom style={{ color: 'var(--mexx-green-primary)', fontWeight: 500 }}>
            Badges
          </Typography>

          <Grid container spacing={3}>
            {/* Variantes */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Variantes
              </Typography>
              <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
                <Badge variant="default">Default</Badge>
                <Badge variant="primary">Primário</Badge>
                <Badge variant="success">Sucesso</Badge>
                <Badge variant="warning">Atenção</Badge>
                <Badge variant="error">Erro</Badge>
                <Badge variant="info">Info</Badge>
                <Badge variant="neutral">Neutro</Badge>
              </Box>
            </Grid>

            {/* Tamanhos */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Tamanhos
              </Typography>
              <Box display="flex" gap={2} alignItems="center">
                <Badge size="small">Pequeno</Badge>
                <Badge size="medium">Médio</Badge>
                <Badge size="large">Grande</Badge>
              </Box>
            </Grid>

            {/* Formas */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Formas
              </Typography>
              <Box display="flex" gap={2} alignItems="center">
                <Badge shape="rounded">Rounded</Badge>
                <Badge shape="square">Square</Badge>
                <Badge shape="pill">Pill</Badge>
              </Box>
            </Grid>

            {/* Dots e Pulse */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Status Indicators
              </Typography>
              <Box display="flex" gap={3} alignItems="center">
                <Box display="flex" alignItems="center" gap={1}>
                  <Badge variant="success" dot />
                  <span>Online</span>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Badge variant="error" dot pulse />
                  <span>Live (com pulse)</span>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Badge variant="warning" dot />
                  <span>Away</span>
                </Box>
              </Box>
            </Grid>

            {/* Contadores */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Contadores
              </Typography>
              <Box display="flex" gap={2} alignItems="center">
                <Badge.Counter count={5} variant="primary" />
                <Badge.Counter count={99} variant="error" />
                <Badge.Counter count={150} max={99} variant="warning" />
                <Badge.Counter count={0} showZero variant="info" />
              </Box>
            </Grid>

            {/* Status */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
                Status Badges
              </Typography>
              <Box display="flex" gap={2} flexWrap="wrap">
                <Badge.Status status="active" text="Ativo" />
                <Badge.Status status="pending" text="Pendente" />
                <Badge.Status status="approved" text="Aprovado" />
                <Badge.Status status="rejected" text="Rejeitado" />
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Info Box */}
        <Card variant="info" style={{ marginTop: 48 }}>
          <Typography variant="h6" gutterBottom>
            ℹ️ Sobre o Redesign Mexx
          </Typography>
          <Typography variant="body2" paragraph>
            Esta é a demonstração da <strong>Fase 1</strong> do redesign do sistema Mexx 2DO.
          </Typography>
          <Typography variant="body2" paragraph>
            <strong>Identidade Visual:</strong> Clean, profissional, com verde Mexx (#8BC34A) como cor primária.
          </Typography>
          <Typography variant="body2">
            <strong>Componentes Implementados:</strong> Button, Input, Card, Badge, Header Moderno.
          </Typography>
        </Card>
      </Container>
    </>
  );
};

export default MexxShowcase;